<!--
  Forbrukerrådet - Kommunetesten
  @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
  @author Anders Evenrud <anders.evenrud@copyleft.no>
-->
<template>
  <div class="read-more">
    Les mer om <a class="read-more__link" :href="link">Forbrukerrådets kommunetest</a>
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/variables";

.read-more {
  padding: 0;
  margin: 1em 0 1em 0;

  &__link {
    text-decoration: underline !important; // FIXME
  }
}

@media (min-width: $responsive-break) {
  .read-more {
    text-align: right;
  }
}
</style>

<script>
export default {
  data () {
    return {
      link: 'https://www.forbrukerradet.no/siste-nytt/nesset-er-norges-beste-kommune-i-forbrukerradets-test'
      // link: 'https://www.forbrukerradet.no/side/forbrukerradets-kommunetester/'
    }
  }
}
</script>
